const lock = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="M11.31 5.58V4.33a3.31 3.31 0 0 0-6.62 0v1.25H2.53V15h10.94V5.58zm-2 4.7A1.32 1.32 0 1 1 8 9a1.33 1.33 0 0 1 1.32 1.28zM6 4.33a2.05 2.05 0 0 1 4.1 0v1.25H6z"/></svg>',
};

export { lock as default };
